export const $UIKitPrefix = 'UIKit-';
